import React from "react";
import { MdClose } from "react-icons/md";
import { FilterColorScheme, FILTER_COLOR_SCHEMES } from "../../types/filters";

interface ActiveFilterBadgeProps {
  label: string;
  colorScheme: FilterColorScheme;
  onClear: () => void;
}

const ActiveFilterBadge: React.FC<ActiveFilterBadgeProps> = ({
  label,
  colorScheme,
  onClear,
}) => {
  const colorClasses = FILTER_COLOR_SCHEMES[colorScheme];

  return (
    <button
      onClick={onClear}
      className={`group flex items-center gap-1.5 rounded px-2 py-1 font-medium transition-colors hover:opacity-80 ${colorClasses}`}
    >
      <span>{label}</span>
      <MdClose className="h-3.5 w-3.5 transition-transform group-hover:scale-110" />
    </button>
  );
};

export default ActiveFilterBadge;
